import { Store } from '@tanstack/react-store';

export type HubspotPanelTab =
  | 'overview'
  | 'checks'
  | 'media'
  | 'details'
  | 'activity';

interface HubspotPanelState {
  /** Persists across tickets so a reviewer stepping through "Checks" stays there. */
  activeTab: HubspotPanelTab;
  isTokenJsonExpanded: boolean;
  isPermissionsExpanded: boolean;
}

export const hubspotPanelStore = new Store<HubspotPanelState>({
  activeTab: 'overview',
  isTokenJsonExpanded: false,
  isPermissionsExpanded: false,
});

export const setActiveTab = (activeTab: HubspotPanelTab) => {
  hubspotPanelStore.setState((prev) => ({ ...prev, activeTab }));
};

export const toggleTokenJson = () => {
  hubspotPanelStore.setState((prev) => ({
    ...prev,
    isTokenJsonExpanded: !prev.isTokenJsonExpanded,
  }));
};

export const togglePermissions = () => {
  hubspotPanelStore.setState((prev) => ({
    ...prev,
    isPermissionsExpanded: !prev.isPermissionsExpanded,
  }));
};
